// src/admin/pages/AuditLog.jsx
import React, { useEffect, useState } from 'react';
import { Chip } from '@mui/material';
import PageHeader from '../components/PageHeader';
import DataTable from '../components/DataTable';
import { fetchAuditLog } from '../lib/adminApi';
import { toDate } from '../lib/adminLogic';

export default function AuditLog() {
  const [entries, setEntries] = useState([]);
  useEffect(() => {
    (async () => {
      const rows = await fetchAuditLog();
      rows.sort((a, b) => (toDate(b.timestamp)?.getTime() || 0) - (toDate(a.timestamp)?.getTime() || 0));
      setEntries(rows);
    })();
  }, []);

  const columns = [
    { key: 'timestamp', label: 'Data', render: (r) => toDate(r.timestamp)?.toLocaleString() || '' },
    { key: 'actorEmail', label: 'Amministratore', sortable: true },
    { key: 'action', label: 'Azione', sortable: true, render: (r) => <Chip size="small" label={r.action} /> },
    { key: 'targetType', label: 'Tipo' },
    { key: 'targetId', label: 'Target' },
  ];

  return (
    <>
      <PageHeader title="Audit Log" subtitle={`${entries.length} azioni registrate`} />
      <DataTable columns={columns} rows={entries} searchable searchKeys={['actorEmail', 'action', 'targetId']} />
    </>
  );
}
